function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  flex-shrink: 0; // flex-shrink-0\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1; // flex-grow\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    font-family: monospace;\n    font-weight: bold;\n    letter-spacing: 0.02em;\n  "
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    opacity: 0.5;\n    cursor: not-allowed;\n  "
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  text-align: left;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  gap: 0.75rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: ",
        ";\n  border-radius: 0.5rem;\n  transition: background 0.18s, color 0.18s, box-shadow 0.18s;\n  position: relative;\n  min-height: 32px;\n  ",
        "\n  &:hover:not(:disabled), &:focus-visible:not(:disabled) {\n    background: var(--theme-bg-hover, #f3f6fa);\n    color: var(--theme-primary, #2563eb);\n    box-shadow: 0 2px 8px rgba(37,99,235,0.06);\n    outline: none;\n  }\n  &:active:not(:disabled) {\n    background: var(--theme-bg-active, #e0e7ef);\n    color: var(--theme-primary-dark, #1e40af);\n  }\n  ",
        "\n  & + & {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { css } from '@emotion/react';
// Variant 색상 가져오기
var getVariantColor = function(theme, variant) {
    switch(variant){
        case 'danger':
            return theme.error || '#DC2626'; // text-red-600
        case 'success':
            return theme.success || '#16A34A'; // text-green-600
        case 'warning':
            return theme.warning || '#D97706'; // text-yellow-600
        case 'info':
            return theme.info || '#2563EB'; // text-blue-600
        case 'default':
        default:
            return theme.text || '#374151'; // text-gray-700
    }
};
export var StyledIconWrapper = styled.span(_templateObject());
export var StyledContentWrapper = styled.span(_templateObject1());
export var StyledMenuItemButton = styled.button(_templateObject4(), function(param) {
    var theme = param.theme, variant = param.variant;
    return getVariantColor(theme, variant);
}, function(param) {
    var $currencyItem = param.$currencyItem;
    return $currencyItem && css(_templateObject2());
}, function(param) {
    var disabled = param.disabled;
    return disabled && css(_templateObject3());
});
